import React from 'react'
import { SelectField } from 'components/final-form'
import { range } from 'lodash'
import { required } from 'components/global/form/FormValidations'
import I18n from 'translations/i18n'
import { jobTitlesLoad } from 'redux/actions/jobTitleActions'
import { useDispatch, useSelector } from 'react-redux'

import Frame from '../../../ds/Frame'

const MONTHS = [
  { id: 1, name: I18n.t('january') },
  { id: 2, name: I18n.t('february') },
  { id: 3, name: I18n.t('march') },
  { id: 4, name: I18n.t('april') },
  { id: 5, name: I18n.t('may') },
  { id: 6, name: I18n.t('june') },
  { id: 7, name: I18n.t('july') },
  { id: 8, name: I18n.t('august') },
  { id: 9, name: I18n.t('september') },
  { id: 10, name: I18n.t('october') },
  { id: 11, name: I18n.t('november') },
  { id: 12, name: I18n.t('december') },
]

const HiringDetails = () => {
  const dispatch = useDispatch()
  const { job_titles: jobTitles } = useSelector(({ jobTitle }) => jobTitle)

  React.useEffect(() => {
    dispatch(jobTitlesLoad({ template: 'public' }))
  }, [])

  return (
    <Frame title={I18n.t('hiring_request')}>
      <SelectField
        label={I18n.t('position')}
        validate={required}
        testId="positionHiringRequest"
        name="position"
        valueKey="name"
        labelKey="name_i18n"
        options={[...jobTitles, { name: 'other', name_i18n: I18n.t('other') }]}
        maxMenuHeight={250}
        menuPlacement="bottom"
      />
      <SelectField
        validate={required}
        testId="monthHiringRequest"
        name="month"
        valueKey="id"
        labelKey="name"
        label={I18n.t('month')}
        options={MONTHS}
        maxMenuHeight={250}
        menuPlacement="bottom"
      />
      <SelectField
        testId="employees_numberHiringRequest"
        name="employees_number"
        label={I18n.t('number_of_employees')}
        validate={required}
        valueKey="value"
        labelKey="key"
        options={range(1, 11).map((v) => {
          return { key: v, value: v }
        })}
        maxMenuHeight={250}
        menuPlacement="bottom"
      />
    </Frame>
  )
}

export default HiringDetails
